export const state = () => ({
  flights: {
    onward: [],
    intermediate: [],
    return: []
  }
});

export const mutations = {
  manage_flights(state, { index, type, route }) {
    if (type == "reset") state.flights = { onward: [], intermediate: [], return: [] };
    else if (type == "add")
      state.flights[route].push({ origin: "", destination: "", airline: "", departure_time: "", arrival_time: "", is_next_day: false, duration: "" });
    else state.flights[route].splice(index, 0);
  }
};

export const getters = {
  flights: (state) => state.flights
};
